const simProductsData = (t) => {
  const simProductsColumns = [
    {
      Header: "Name",
      accessor: "name",
      sortable: true,
      canRenderFilter: true,
    },
    {
      Header: "Description",
      accessor: "description",
      sortable: false,
      canRenderFilter: false,
    },
  ];

  return { simProductsColumns };
};

export default simProductsData;
